import axios from 'axios';
import config from '../../../../config';
export {
  getLabOrdersTimeline as getOrderTimeline,
  postFactoSubmitDigitsationRequest,
} from '../../../../services/lab-test';

export function getAddressFromLatLng(lat, lng, authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/location/decode`, {
      headers,
      params: {
        lat,
        lng,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      return responseBody;
    })
    .catch((err) => {
      throw err;
    });
}

export function getLabHomePageData(authToken, lat, lng) {
  const url = `${config.apiBaseUrl}/labs-v2/dashboard-v4?lat=${lat}&lng=${lng}`;
  const headers = {
    authorization: authToken,
  };

  return axios.get(url, { headers }).then((resp) => {
    const responseBody = resp.data;
    return responseBody;
  });
}

export function initiateCallByUser(authToken, orderId) {
  const url = `${config.apiBaseUrl}/labs-v2/order/initiate-call-by-user`;
  const headers = {
    authorization: authToken,
  };

  return axios.post(url, { orderId }, { headers }).then((resp) => {
    return resp.data;
  });
}

export async function getPrescriptions(authToken) {
  const url = `${config.apiBaseUrl}/labs-v3/list-prescriptions`;
  const headers = {
    authorization: authToken,
  };

  return axios.get(url, { headers }).then((resp) => {
    const responseBody = resp?.data?.data;
    return responseBody;
  });
}

export async function getGuideData(authToken, type = 'labs') {
  const url = `${config.physioBaseUrl}/upload-rx-guide?type=${type}`;
  const headers = {
    authorization: authToken,
  };
  return axios.get(url, { headers }).then((resp) => {
    const responseBody = resp.data;
    console.log('$$$$$$$$', responseBody);
    return responseBody;
  });
}

export async function findDigitisedCart(digitisationId, authToken) {
  const url = `${config.apiBaseUrl}/labs-v3/cart/findDigitisedCart?digitisationId=${digitisationId}`;
  const headers = { authorization: authToken };
  return axios.get(url, { headers }).then((resp) => resp.data);
}

export async function addCartTest(cartItemId, cartId, authToken) {
  const headers = { authorization: authToken };
  return axios
    .post(
      `${config.apiBaseUrl}/labs-v3/cart/test/add`,
      { cartItemId, cartId },
      { headers }
    )
    .then((resp) => resp.data);
}

export async function removeCartTest(cartItemId, cartId, authToken) {
  const headers = { authorization: authToken };
  return axios
    .post(
      `${config.apiBaseUrl}/labs-v3/cart/test/remove`,
      { cartItemId, cartId },
      { headers }
    )
    .then((resp) => resp.data);
}

export function getTestItems(authToken, orderId, packageId, cartId) {
  const headers = {
    authorization: authToken,
  }; // Build params dynamically

  let params = [];

  if (cartId) {
    params.push(`cartId=${cartId}`);
  }

  if (orderId) {
    params.push(`orderId=${orderId}`);
  }

  if (packageId) {
    params.push(`packageId=${packageId}`);
  }

  const queryString = params.join('&');

  return axios
    .get(`${config.apiBaseUrl}/labs-v3/get-test-items?${queryString}`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}

export async function updateScanNPayCart(
  { cartId, patientId, collectionDate, slotId, partnerId, partnerCenterId },
  authToken
) {
  const headers = { authorization: authToken };
  return axios
    .post(
      `${config.apiBaseUrl}/labs-v3/cart/updateScanNPayCart`,
      {
        cartId,
        patientId,
        type: 'scanNpay',
        collectionDate,
        slotId,
        partnerId,
        partnerCenterId,
      },
      { headers }
    )
    .then((resp) => resp.data);
}
export function selectPrescription(authToken, cartId, validTill) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(
      `${config.apiBaseUrl}/labs-v3/select-prescription`,
      { cartId, validTill },
      { headers }
    )
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}

export function selectPostFactoPrescription(authToken, payload) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/labs-v3/select-prescription`, payload, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}
